<template>
    <form v-on:submit.prevent="handleSubmit();">
        <div class="form-group mt-4">
            <div class="row">
                <div class="col-lg-3">
                    <label>Nuværende adgangskode</label>
                    <input 
                    type="password" 
                    v-model="payload.currentPassword" 
                    class="form-control" 
                    placeholder="••••••" 
                    >
                </div>
                <div class="col-lg-3">
                    <label>Ny adgangskode</label>
                    <input 
                    type="password" 
                    v-model="payload.newPassword" 
                    class="form-control" 
                    placeholder="••••••" 
                    >
                </div>
                <div class="col-lg-3">
                    <label>Bekræft adgangskode</label>
                    <input 
                    type="password" 
                    v-model="payload.newPassword_confirmation" 
                    class="form-control" 
                    placeholder="••••••" 
                    >
                </div>
                <div class="col-lg-3">
                    <button type="submit" class="btn btn-primary btn-block" style="margin-top: 1.9rem;">
                        <span v-if="isLoading"><div class="loader mx-auto"></div></span>
                        <span v-else>Skift adgangskode</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="help-text">
            <p 
            class="text-danger"
            v-for="error of formErrors"
            v-bind:key="error.key"
            >{{ error }}</p>
        </div>
    </form>
</template>

<script>
export default {
    data: function() {
        return {
            payload: {},

            formErrors: [],

            isLoading: false,
        }
    },

    methods: {
        changePassword() {
            this.axios.post('auth/user/change-password', this.payload)
                .then(res => {
                    this.isLoading = false;
                    for(var property in this.payload) {
                        this.payload[property] = '';
                    }

                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'Din adgangskode blev opdateret!',
                        text: 'Husk at benytte din nye adgangskode næste gang, du logger på',
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    let errors = error.response.data.errors;
                    for(var property in errors) {
                        let error = errors[property][0];

                        switch (error) {
                            case "Password is invalid":
                            error = "Nuværende adgangskode ikke korrekt.";
                            break;
                            
                            case "The current password field is required.":
                            error = "Feltet nuværende adgangskode er påkrævet."
                            break;

                            case "The new password field is required.":
                            error = "Feltet ny adgangskode er påkrævet.";
                            break;
                            
                            case "The new password must be at least 8 characters.":
                            error = "Din nye adgangskode skal mindst være 8 tegn.";
                            break;

                            case "The new password confirmation does not match.":
                            error = "Adgangskoderne er ikke ens. Din nye adgangskode skal stemme overens med bekræft adgangskode.";
                            break;
                        };

                        this.formErrors.push(error);
                    }
                });
        },

        handleSubmit() {
            this.formErrors = [];
            this.isLoading = true;

            this.changePassword();
        }
    }
}
</script>

